import './FleetMeetTheCar.scss';

import Button from '../../ui/Button/Button';
import React from 'react';
import cn from 'classnames';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function FleetMeetCar({ fields }) {
  return (
    <div className={'container fleet-meet-car'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'card'}>
          <div className={'card_inner'}>
            <div>
              <h3 className={'card_title'}>{fields?.title?.value}</h3>
              <p className={'card_text'}>{fields?.desc?.value}</p>
            </div>
            {/* {buttons && buttons.length > 0 && ( */}
            <div className={'buttons'}>
              <div className={'buttonWrapper'}>
                <a href={fields?.buttonUrl?.value?.href}>
                  <Button className={'buttonWrapper_button'} isShowTooltip={false}>
                    {fields?.buttonText?.value}
                  </Button>
                </a>
              </div>
              <div className={'buttonWrapper'}>
                <a href={fields?.buttonSecondUrl?.value?.href}>
                  <Button
                    className={cn('buttonWrapper_button', 'secondary')}
                    variant={'secondary'}
                    isShowTooltip={false}
                  >
                    {fields?.buttonSecondText?.value}
                  </Button>
                </a>
              </div>
            </div>
            {/* )} */}
          </div>
        </div>
        <div className={'image'}>
          <Image field={fields?.image} alt="img" />
        </div>
      </div>
    </div>
  );
}
